import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as space from '../../space'

export const RESOURCE = {
  payload: {
    description: 'A designated room within a building.',
    dimension: space.RESOURCE.payload,
    level: 3,
    name: 'Room',
    partialId: PartialId.Standard.create('room'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
